import { get } from "lodash";
import { WidgetFactory } from "./WidgetFactory";
import { WidgetService } from "./WidgetService";

type CallbackAfterAuth = (certificates: Record<string, any>[]) => void;
const callbackAfterAuthFn: CallbackAfterAuth = () => "";

export interface IEds {
  hasWidget(): boolean
  loadWidget(): Promise<void>
  sign(data: string): Promise<string>
  destroy(): void
}

export class Eds implements IEds {
  constructor(
    private signWidgetUrl: string,
    private cbAfterAuth: CallbackAfterAuth = callbackAfterAuthFn,
  ) {}

  private _endUser?: Record<string, any>;

  hasWidget(): boolean {
    return Boolean(this._endUser);
  }

  async loadWidget(): Promise<void> {
    const widgetFactory = new WidgetFactory(this.signWidgetUrl);
    const widget = await widgetFactory.create();
    const widgetService = new WidgetService(widget, this.cbAfterAuth);

    widgetService.addReadKeyListener();
    this._endUser = widget;
  }

  async sign(data: string): Promise<string> {
    if (this._endUser === undefined) {
      throw new Error("Бібліотеку підпису не ініціалізовано");
    }

    const options = {
      external: false,
      asBase64String: true,
      signType: get(window, "EndUser.SignType.CAdES_X_Long"),
      previousSign: null,
      signAlgorithm: get(window, "EndUser.SignAlgo.DSTU4145WithGOST34311"),
    };

    const endUser = await this._endUser["SignData"](
      data,
      options.external,
      options.asBase64String,
      options.signAlgorithm,
      options.previousSign,
      options.signType,
    );

    return endUser;
  }

  destroy(): void {
    if (this._endUser === undefined) {
      throw new Error("Бібліотеку підпису не ініціалізовано");
    }

    this._endUser["destroy"]();
  }
}
